import { tuningHistoryToFirestore } from '@parallel-fluidics/shared/models/tuningHistory';
import {
  doc,
  getFirestore,
  updateDoc,
} from 'firebase/firestore';

export default function updateTuningHistory(id, tuningHistoryData) {
  const docData = tuningHistoryToFirestore(tuningHistoryData);
  return updateDoc(doc(getFirestore(), 'tuningHistory', id), docData);
}
